import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=0cf349ce&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=0cf349ce&prod&lang=scss&scoped=true&"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&id=0cf349ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf349ce",
  null
  
)

export default component.exports